module.exports = __webpack_public_path__ + "media/dashboard/assets/images/conversate_header-d2f139193ef1692ae0b5847e2fe842ed.png";